<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <div class="d-flex align-center flex-wrap payment-callback__header">
        <v-chip
          small
          label
          :color="statusColor"
          class="v-chip-light-bg me-3"
          :class="`${statusColor}--text`"
        >
          {{ statusText }}
        </v-chip>
        <span class="me-4">{{ receivedAt }}</span>
        <span
          v-if="callback.payment"
          class="font-weight-medium me-4"
        >{{ callback.payment.amount }} с</span>
        <span class="text--secondary me-4">попыток: {{ callback.attemptCount }}</span>
        <span
          v-if="callback.remoteIp"
          class="text--secondary"
        >{{ callback.remoteIp }}</span>
      </div>
    </v-expansion-panel-header>

    <v-expansion-panel-content>
      <div
        v-if="callback.error"
        class="payment-callback__error mb-4"
      >
        {{ callback.error }}
      </div>

      <template v-if="callback.payment">
        <p class="font-weight-medium text--primary mb-2">
          Платёж
        </p>
        <v-simple-table
          dense
          class="mb-6"
        >
          <tbody>
            <tr
              v-for="row in paymentRows"
              :key="row.title"
            >
              <td class="text--secondary payment-callback__title">
                {{ row.title }}
              </td>
              <td>{{ row.value }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </template>
      <p
        v-else
        class="text--secondary mb-6"
      >
        Тело ещё не разобрано в платёж.
      </p>

      <p class="font-weight-medium text--primary mb-2">
        Попытки разбора
      </p>
      <v-simple-table
        dense
        class="mb-6"
      >
        <thead>
          <tr>
            <th>№</th>
            <th>Начало</th>
            <th>Конец</th>
            <th>Итог</th>
            <th>Ошибка</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="attempt in callback.attempts"
            :key="attempt.number"
          >
            <td>{{ attempt.number }}</td>
            <td class="text-no-wrap">
              {{ dateTime(attempt.startedAt) }}
            </td>
            <td class="text-no-wrap">
              {{ dateTime(attempt.finishedAt) }}
            </td>
            <td>
              <span :class="attempt.isSuccessful ? 'success--text' : 'error--text'">
                {{ attempt.isSuccessful ? 'успех' : 'неудача' }}
              </span>
            </td>
            <td class="payment-callback__attempt-error">
              {{ attempt.error }}
            </td>
          </tr>
          <tr v-if="!callback.attempts || !callback.attempts.length">
            <td
              colspan="5"
              class="text--secondary"
            >
              Попыток ещё не было.
            </td>
          </tr>
        </tbody>
      </v-simple-table>

      <p class="font-weight-medium text--primary mb-2">
        Тело колбэка
      </p>
      <pre class="payment-callback__body">{{ body }}</pre>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { toDateTimeString } from '@/helpers/index'
import { callbackStatusColor, callbackStatusText } from '@/helpers/payments'

export default {
  name: 'PaymentCallbackPanel',
  props: {
    callback: {
      type: Object,
      required: true,
    },
  },
  computed: {
    statusText() {
      return callbackStatusText(this.callback.status)
    },
    statusColor() {
      return callbackStatusColor(this.callback.status)
    },
    receivedAt() {
      return toDateTimeString(this.callback.receivedAt)
    },
    paymentRows() {
      const payment = this.callback.payment

      return [
        { title: 'Счёт', value: payment.accountNo },
        { title: 'Сумма', value: payment.amount },
        { title: 'Валюта', value: payment.currencyId },
        { title: 'Ключ операции', value: payment.operationId },
        { title: 'Состояние операции', value: payment.operationState },
        { title: 'Транзакция QR', value: payment.qrTransactionId },
        { title: 'ELQR', value: payment.elqrId },
        { title: 'Оплачен', value: toDateTimeString(payment.paidAt) },
        { title: 'Разобран', value: toDateTimeString(this.callback.processedAt) },
      ].filter(row => row.value !== null && row.value !== undefined && row.value !== '')
    },
    body() {
      try {
        return JSON.stringify(JSON.parse(this.callback.body), null, 2)
      } catch {
        return this.callback.body
      }
    },
  },
  methods: {
    dateTime(value) {
      return toDateTimeString(value)
    },
  },
}
</script>

<style lang="scss" scoped>
.payment-callback__header {
  row-gap: 4px;
}

.payment-callback__title {
  width: 220px;
}

.payment-callback__error,
.payment-callback__attempt-error {
  color: var(--v-error-base);
  font-size: 0.8125rem;
  white-space: pre-line;
}

.payment-callback__body {
  max-height: 320px;
  overflow: auto;
  padding: 12px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.04);
  font-size: 0.8125rem;
  line-height: 1.4;
}

.theme--dark .payment-callback__body {
  background: rgba(255, 255, 255, 0.06);
}
</style>
